// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ZecY","vLegacy":"SelectSecondary_vLegacy__3psMM","error":"SelectSecondary_error__2ViLZ","disabled":"SelectSecondary_disabled__37D6v"};